/**
 * 学习乐园 · 连连看题材包：反义词（lianliankan/pack-fanyici.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：词连它的反义词（「大」连「小」）。note 存一句生活化场景
 * （「大象大蚂蚁小」）——配上那一瞬顺口念一遍，反义关系挂在具体事物上
 * 比抽象背词表记得牢（栏目「玩着玩着就会了」口径）。
 * 注意：同包 24 对的左右牌面全部互不重复——l 与 r 都在同一棋盘上，
 * 一旦某词跨对出现（既是甲对的左牌又是乙对的右牌），配错反馈就会
 * 指错搭档（rel 型按 pair 报 mate，同 face 两张牌玩家无法区分）。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.fanyici = {
    id: 'fanyici',
    name: '反义词',
    hint: '大连小、高通低，成对记反义',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '大', r: '小', note: '大象大，蚂蚁小' },
      { l: '高', r: '低', note: '山顶高，谷底低' },
      { l: '长', r: '短', note: '尺子量长短' },
      { l: '多', r: '少', note: '星星多，数不清' },
      { l: '上', r: '下', note: '电梯上上下下' },
      { l: '前', r: '后', note: '排队看前后' },
      { l: '左', r: '右', note: '写字多用右手' },
      { l: '东', r: '西', note: '太阳东升西落' },
      { l: '开', r: '关', note: '按开关开灯' },
      { l: '冷', r: '热', note: '冰凉火烫' },
      { l: '快', r: '慢', note: '猎豹快，蜗牛慢' },
      { l: '明', r: '暗', note: '开灯明，关灯暗' },
      { l: '真', r: '假', note: '真金不怕火炼' },
      { l: '新', r: '旧', note: '新书没有折角' },
      { l: '买', r: '卖', note: '买东西要付钱' },
      { l: '胜', r: '负', note: '比赛分胜负' },
      { l: '进', r: '出', note: '进门与出门' },
      { l: '内', r: '外', note: '屋内屋外' },
      { l: '早', r: '晚', note: '早起床，晚睡觉' },
      { l: '黑', r: '白', note: '熊猫黑白色' },
      { l: '干', r: '湿', note: '干毛巾吸水' },
      { l: '轻', r: '重', note: '羽毛轻，石头重' },
      { l: '厚', r: '薄', note: '字典厚，纸片薄' },
      { l: '曲', r: '直', note: '绳弯曲，尺笔直' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
